import { useContext } from "react";
import RHNotificationContext, {
  ProviderContext
} from "./RHNotificationContext";

export default (): ProviderContext => useContext(RHNotificationContext);
